/**
 * ExamRegistration scene sagas
 *
 * @author Carlos Silva <csilva@ubiwhere.com>
 *
 */

import { takeLatest } from 'redux-saga/effects';

//import { actions } from 'store/rootSlices'

function* onMountSaga() {}

function* onUnmountSaga() {}

export default function* watcherSignin() {
  yield takeLatest('ExamRegistration/onMount', onMountSaga);
  yield takeLatest('ExamRegistration/onUnmount', onUnmountSaga);
}
